import { Alert } from '@mui/material';
import React from 'react';

const Instructions = ({ children }) => {
    return (
        <Alert
            severity="info" 
            sx={{ 
                my: 2, 
                fontSize: "13px", 
                backgroundColor: `rgb(184, 231, 251) !important`,
                '& p, & span': {
                    marginBottom: 0
                }
            }}
        >
            <div dangerouslySetInnerHTML={{ __html: children }} />
        </Alert>
    );
}

export default Instructions;
